/* eslint-disable import/prefer-default-export, no-console */
export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem('userSession', serializedState)
  } catch (err) {
    console.error(err)
  }
}
